import { useCallback } from 'react';

import { useSearchParams } from '@remix-run/react';

import { FEED_VIEW_DEFAULT, type FeedView, normalizeFeedView } from '~/constants/community';

export { normalizeFeedView };

export const useFeedView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView = normalizeFeedView(searchParams.get('view'));

  const setFeedView = useCallback(
    (next: FeedView) => {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          if (next === FEED_VIEW_DEFAULT) params.delete('view');
          else params.set('view', next);
          return params;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return { activeView, setFeedView };
};
